export default {
  fields: {
    demo: {
      label: 'Creează demo',
    },
    ai: {
      label: 'Optimizat AI',
    },
    restaurant_type: {
      label: 'Selectați tipul restaurantului',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Livrare pizza 🍕🚗',
        PizzaNeapolitan: 'Pizza napolitană 🍕',
        Italian: 'Italian 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Turcesc 🇹🇷',
        Mexican: 'Mexican 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japonez 🇯🇵',
        Vietnamese: 'Vietnamez 🇻🇳',
        Thai: 'Thai 🇹🇭',
        Asian: 'Asiatic 🍜',
        Indian: 'Indian 🥘',
        Bowls: 'Boluri 🥣',
        Vegan: 'Vegan 🥑',
        Greek: 'Grecesc 🏛️',
        Cafe: 'Cafenea ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Oriental / Orientul Mijlociu 🧆',
        Spanish: 'Spaniol / Tapas 🇪🇸',
        Persian: 'Persan 🫖',
      },
    },
    plugins: {
      reservations: 'Rezervări',
      reservations_plan_hint:
        'Rezervările necesită un Plan Partner. Vei fi întrebat dacă dorești să îl activezi pentru {{name}} când creezi site-ul.',
      catering: 'Catering',
      events: 'Evenimente',
    },
    quarter: {
      label: 'Cartier',
      address_placeholder: 'Introduceți adresa',
      quarter_placeholder: 'Introduceți cartierul',
    },
    delivery_areas: {
      label: 'Ce zone din oraș deserviți?',
      city_placeholder: 'Introduceți orașul',
      district_placeholder: 'Cartier 1, Cartier 2, Cartier 3',
    },
    best_dishes: {
      label: 'Care sunt cele mai bune 3 preparate ale dvs.?',
      placeholder: 'Introduceți preparate (Burger pui, Burger brânză etc.)',
    },
    dietary_attributes: {
      label: 'Aveți opțiuni pentru persoanele care doresc să mănânce:',
      placeholder: 'Selectați atributele dietetice',
      types: {
        vegetarian: 'Vegetarian',
        vegan: 'Vegan',
        halal: 'Halal',
        gluten_free: 'Fără gluten',
        dairy_free: 'Fără lactoză',
        spicy: 'Picant',
      },
    },
    family_owned: {
      label: 'Afacere de familie?',
      yes: 'Da',
      no: 'Nu',
    },
    business_founding_year: {
      label: 'Când a fost înființat restaurantul (ce an)?',
    },
    business_owners: {
      label: 'Proprietari',
      placeholder: 'Introduceți proprietarul',
    },
    notes: {
      label: 'Adăugați note suplimentare (opțional)',
      placeholder: 'Ex. restaurant orientat spre comunitate, inițiative, deținut de un cuplu...',
    },
    about_us: {
      title: 'Despre noi (previzualizare)',
    },
  },
  sections: {
    plugins: 'Pluginuri',
    company_info: 'Generează informații companie',
  },
  buttons: {
    find_district: 'Găsește cartierul',
    generate: 'Generează',
    products: 'Produse',
    add: 'Adaugă',
  },
};
